export default (context) => ({
  httpGetCategories() {
    return context.$http.get(
      `${context.$store.state.ticket_api_base_url}/ticket-categories`
    )
  },
})
